import { databaseState } from './state.ts';

(window as any).databaseState = databaseState;
